import { useEffect, useRef } from 'react';

const useAutoScroll = (dependencies: React.DependencyList) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, dependencies); 

  return containerRef;
};

export default useAutoScroll;
